import React             from 'react';
import { Grid, Cell }    from 'styled-css-grid';
import { StringOrEmpty } from "@src/views/components/display/StringOrEmpty";
import './styles/DashCharts.scss';

interface DashSingleValueProps {
   data: any,
   title: string;
}

const DashSingleValue: React.FC<DashSingleValueProps> = (props) => {
    if(!props.data) return null;

    // Format the data value for display
    const formatValue = (value: any): string => {
        if (value === null || value === undefined) return '--';

        // If it's an object with milestone and date
        if (typeof value === 'object' && value !== null) {
            if ('milestone' in value && 'date' in value) {
                const milestone = String(value.milestone || '');
                const date = value.date ? new Date(value.date).toLocaleDateString() : '';
                return milestone && date ? `${milestone}: ${date}` : milestone || date || '--';
            }

            // Handle chart data object
            if ('labels' in value && 'datasets' in value) {
                // Extract the first value from the datasets
                if (Array.isArray(value.datasets) && value.datasets.length > 0) {
                    const firstDataset = value.datasets[0];
                    if (firstDataset && Array.isArray(firstDataset.data) && firstDataset.data.length > 0) {
                        const firstValue = firstDataset.data[0];
                        return typeof firstValue === 'number'
                            ? firstValue.toLocaleString()
                            : String(firstValue || '--');
                    }
                }
                return '--'; // Return placeholder if no valid data found
            }

            // For other objects, try to get the first value
            try {
                const firstValue = Object.values(value)[0];
                return firstValue !== null && firstValue !== undefined
                    ? String(firstValue)
                    : '--';
            } catch (e) {
                console.error('Error formatting object value:', e);
                return '--';
            }
        }

        // Format numbers with commas
        if (typeof value === 'number') {
            return value.toLocaleString();
        }

        // Everything else as string
        return String(value);
    };

    // Get the formatted value safely
    let formattedValue;
    try {
        formattedValue = formatValue(props.data);
    } catch (error) {
        console.error('Error formatting value in DashSingleValue:', error);
        formattedValue = '--';
    }

    return (
        <Grid
            className="dash-chart dash-single-value"
            columns={1}
            rows="auto 1fr"
            gap="0.5rem"
            areas={[
                'title',
                'value'
            ]}
        >
            <Cell area="value" className="value">
                {formattedValue}
            </Cell>
        </Grid>
    );
};

export default DashSingleValue;
